import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
export default function PDFView(props) {
  const [PreviewUrl, setPreviewUrl] = React.useState("")
  const [PreviewObj, setPreviewObj] = React.useState({audio_list:"[]"})

  const location = useLocation();
  useEffect(() => {
    var videoid = location.pathname.slice(11)
    var youtubeid = window.atob(videoid)
    setPreviewUrl(youtubeid)
    var pdf = localStorage.getItem("pdf")
    console.log(pdf)
    var thisPdf = JSON.parse(pdf)
    setPreviewObj(thisPdf)
  },[])
  const color = "#00000022"
  return (
    <div>
      <div style={{ minHeight: "100vh", overflowY: "scroll", overflowX: "hidden" }}>
        <div style={{minHeight:"8vh"}}>
          {Object.values(JSON.parse(PreviewObj.audio_list)).length !== 0 &&
            <>
              <div className="row">
                <div className="col-sm-9" style={{ whiteSpace: "nowrap", overflowX: "scroll" }}>
                  <div style={{ overflow: "auto", display: "inline", }}>
                    {Object.values(JSON.parse(PreviewObj.audio_list)).map((item, index) => (
                      <div key={index} style={{ display: "inline-block" }}>
                        {item.audio_url.includes("https") &&
                          <div className="shadow" style={{ cursor: "pointer", backgroundColor: "#fff", margin: "5px", padding: "6px", borderRadius: 10 }}
                            onClick={() => {
                              // setAudioUrl(item)
                            }}
                          >
                            <center>
                              <div onClick={() => { }}>
                                <AudioComp media={item.audio_url} />
                              </div>
                              <div style={{ fontSize: "8px" }}>
                                {item.audio_url.split("/")[item.audio_url.split("/").length - 1].replace(".mp3", "")}
                              </div>
                            </center>
                          </div>
                        }
                      </div>
                    ))}

                  </div>
                </div>
              </div>
            </>
          }
        </div>
        <div>
          <iframe style={{ width: "100vw", height: "92vh", position: "absolute", zIndex: 1 }}

            src={`https://drive.google.com/viewerng/viewer?embedded=true&url=${PreviewUrl}`} />
          <div >
          </div>
          <div style={{ padding: "37vh 50vw", backgroundColor: "#eee" }}>
            <div className="dot-pulse-2"></div>
          </div>
        </div>

      </div>
    </div>
  )
}



const styles = {
  border: '0.0625rem solid #9c9c9c',
  borderRadius: '0.25rem',
};


const AudioComp = ({ media }) => {
  const [isPlayingMedia, setIsPlayingMedia] = React.useState(true)
  const audiocontrl = React.useRef()
  const sound = new Audio(media)
  return (
    <div>
      <audio controls={false} autoplay style={{ width: "90px" }} ref={audiocontrl}>
        <source src={`${media}`} type="audio/mpeg" />
        <source src={`${media}`} type="audio/mp3" />
        <source src={`${media}`} type="audio/wav" />
        <source src={`${media}`} type="audio/ogg" />
        Your browser does not support the audio element.
      </audio>
      <div>
        <div onClick={() => {
          setIsPlayingMedia(!isPlayingMedia)
          if (isPlayingMedia)
            audiocontrl.current?.play()
          else
            audiocontrl.current?.pause()
        }}>
          {!isPlayingMedia ?
            <i className="fa fa-pause" style={{ fontSize: "13px" }}></i>
            :
            <i className="fa fa-play " style={{ fontSize: "13px" }}></i>
          }
        </div>
      </div>
    </div>
  )
}